// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"3ac54db6","263":"6138694d","264":"9b065823","365":"38c531c4","868":"94eb8a9e"}[chunkId] + ".chunk.js";
};